module.exports = __webpack_public_path__ + "img/cancelado_a.0b99c23a.png";